const onlyDigits = v => String(v || '').replace(/\D/g, '');

export function maskCPF(value) {
  if (!value) return '-';
  const d = onlyDigits(value);
  if (d.length !== 11) return '***.***.***-**';

  const first3 = d.slice(0, 3);
  const last2 = d.slice(-2);

  return `${first3}.***.***-${last2}`;
}

export function maskCNPJ(value) {
  if (!value) return '-';
  const d = onlyDigits(value);
  if (d.length < 2) return '**.***.***/****-**';
  const last2 = d.slice(-2);
  return `**.***.***/****-${last2}`;
}

export function maskPhone(value) {
  if (!value) return '-';
  const d = onlyDigits(value);
  const last4 = d.slice(-4);
  const ddd = d.length >= 10 ? d.slice(0, 2) : '**';
  return `(${ddd}) *****-${last4 || '****'}`;
}

export function maskEmail(value) {
  if (!value) return '-';
  const email = String(value).trim();
  const [user, domain] = email.split('@');

  if (!user || !domain) return '***@***';

  const userPrefix = user.slice(0, Math.min(2, user.length));

  const parts = domain.split('.');
  const last = parts[parts.length - 1] || '***';
  const secondLast = parts[parts.length - 2] || '';
  const commonSecondLevel = ['com', 'org', 'net', 'gov', 'edu', 'co'];

  const tld =
    parts.length >= 2 &&
    last.length === 2 &&
    commonSecondLevel.includes(secondLast)
      ? `.${secondLast}.${last}` // ex.: .com.br
      : `.${last}`; // ex.: .com

  const firstDomainChar = (parts[0] && parts[0][0]) || '*';
  return `${userPrefix}***@${firstDomainChar}***${tld}`;
}

// opcional (útil para holder name)
export function maskName(value) {
  if (!value) return '-';
  const name = String(value).trim();
  if (!name) return '-';
  const first = name.split(/\s+/)[0];
  return `${first} ****`;
}

export function maskBirthDate(value) {
  if (!value) return '-';
  return '**/**/****';
}
